<template>
<div>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="all_menu_restaurant">
            <v-card class="list_menu_restaurant">
                <router-link to="/poslist" class="menu_card_restaurant d-flex flex-column justify-center align-center">
                    <div class="img_menu_restaurant">
                        <img src="@/assets/icon-restaurant-pos.png">
                    </div>
                    <div class="title_menu_restaurant">
                        ระบบ POS
                    </div>
                </router-link>
            </v-card>
            <v-card class="list_menu_restaurant">
                <router-link to="/managefood" class="menu_card_restaurant d-flex flex-column justify-center align-center">
                    <div class="img_menu_restaurant">
                        <img src="@/assets/icon-restaurant-menu.png">
                    </div>
                    <div class="title_menu_restaurant">
                        จัดการรายการอาหาร
                    </div>
                </router-link>
            </v-card>
<!--            <v-card class="list_menu_restaurant" v-if="$store.state.userProfile.per_statistic_food == 1">-->
<!--                <router-link to="/salestatistic" class="menu_card_restaurant d-flex flex-column justify-center align-center">-->
<!--                    <div class="img_menu_restaurant">-->
<!--                        <img src="@/assets/fast-food.png">-->
<!--                    </div>-->
<!--                    <div class="title_menu_restaurant">-->
<!--                        ดูสถิติยอดขายอาหาร-->
<!--                    </div>-->
<!--                </router-link>-->
<!--            </v-card>-->
<!--            <v-card class="list_menu_restaurant" v-if="$store.state.userProfile.per_report_retrospect == 1">-->
<!--                <router-link to="/salereport" class="menu_card_restaurant d-flex flex-column justify-center align-center">-->
<!--                    <div class="img_menu_restaurant">-->
<!--                        <img src="@/assets/reportall.png">-->
<!--                    </div>-->
<!--                    <div class="title_menu_restaurant">-->
<!--                        ดูรายงานทั้งหมด-->
<!--                    </div>-->
<!--                </router-link>-->
<!--            </v-card>-->
            <v-card class="list_menu_restaurant" v-if="$store.state.userProfile.per_invoice_retrospect == 1">
                <router-link to="/billretrospectall" class="menu_card_restaurant d-flex flex-column justify-center align-center">
                    <div class="img_menu_restaurant">
                        <img src="@/assets/icon-restaurant-bill.png">
                    </div>
                    <div class="title_menu_restaurant">
                        บิลย้อนหลัง
                    </div>
                </router-link>
            </v-card>
            <v-card class="list_menu_restaurant" v-if="$store.state.userProfile.per_see_close == 1">
                <router-link to="/closeretrospectall" class="menu_card_restaurant d-flex flex-column justify-center align-center">
                    <div class="img_menu_restaurant">
                        <img src="@/assets/icon-restaurant-close-restaurant.png">
                    </div>
                    <div class="title_menu_restaurant">
                        รายการปิดร้านย้อนหลัง
                    </div>
                </router-link>
            </v-card>
            <!-- <v-card class="list_menu_restaurant" v-if="$store.state.userProfile.per_setup_advertise == 1">
                <router-link to="/advertisebuffet" class="menu_card_restaurant d-flex flex-column justify-center align-center">
                    <div class="img_menu_restaurant">
                        <img src="@/assets/icon-restaurant-ads.png">
                    </div>
                    <div class="title_menu_restaurant">
                        โฆษณา
                    </div>
                </router-link>
            </v-card> -->
            <v-card class="list_menu_restaurant" v-if="$store.state.userProfile.per_setup_advertise == 1">
                <router-link to="/advertisebuffet" class="menu_card_restaurant d-flex flex-column justify-center align-center">
                    <div class="img_menu_restaurant">
                        <img src="@/assets/icon-restaurant-ads.png">
                    </div>
                    <div class="title_menu_restaurant">
                        โฆษณา
                    </div>
                </router-link>
            </v-card>
             <v-card class="list_menu_restaurant" v-if="$store.state.userProfile.per_setting_store == 1">
                <router-link to="/settingrestaurant" class="menu_card_restaurant d-flex flex-column justify-center align-center">
                    <div class="img_menu_restaurant">
                        <img src="@/assets/icon-restaurant-settingshop.png">
                    </div>
                    <div class="title_menu_restaurant">
                        ตั้งค่าข้อมูลร้านอาหาร
                    </div>
                </router-link>
            </v-card>
        </div>
    </div>
</div>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
export default {
    name: 'restaurant',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true
        }
    },
    methods: {
        async buffetList() {
            this.loading_page = true
            HTTP.get('/buffet/list', {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        this.loading_page = false
                    }

                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })
        },
    },
    mounted() {
        this.buffetList()
    }
}
</script>

<style scoped>
.all_menu_restaurant{
    display: grid;
    grid-template-columns: 50% 50%;
    grid-row-gap: 8px;

}
</style>
